import { styled } from '@/stitches.config';

export const StyledText = styled('span', {
  color: '$darkGray300',
  display: 'block',
  fontSize: '$sm',
  fontWeight: '$bold',
  letterSpacing: '0.5px',
  lineHeight: '$4',
  marginBottom: '$8',
  textAlign: 'left',
  textTransform: 'uppercase',
});
